import type { App, Plugin } from 'vue';
import Toast, { useToast, POSITION, TYPE } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import type { ToastOptions } from 'vue-toastification';

const pluginOptions = {
  position: POSITION.BOTTOM_RIGHT,
  timeout: 3000,
  pauseOnHover: true,
  closeOnClick: true,
};

export const useToaster = () => {
  const toast = useToast();

  return {
    success: (message: string, options: ToastOptions = {}) =>
      toast(message, { ...pluginOptions, ...options, type: TYPE.SUCCESS }),

    error: (message: string, options: ToastOptions = {}) =>
      toast(message, { ...pluginOptions, ...options, type: TYPE.ERROR }),

    info: (message: string, options: ToastOptions = {}) =>
      toast(message, { ...pluginOptions, ...options, type: TYPE.INFO }),

    raw: toast,
  };
};

export const Toaster: Plugin = {
  install(app: App) {
    app.use(Toast, pluginOptions);
    app.config.globalProperties.$toaster = useToaster();
  },
};

export default useToaster();
